import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';

import { environment } from '@app/env-service';

import { Company, Assignee } from '../store/company.model';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  url :string = environment.url;
  urlV2 :string = environment.urlV2;

  private readonly _companies = new BehaviorSubject<Company[]>([]);
  public companies$ = this._companies.asObservable();

  private readonly _assignee = new BehaviorSubject<Assignee[]>([]);
  public assignee$ = this._assignee.asObservable();

  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  loading$ = this._loading.asObservable();

  constructor(private http :HttpClient) {}

  getRecords() {
    this.http.get(`${this.url}/companies`).subscribe((data :any) => {
      this._companies.next(<Company[]>data.records.data);
    });
    this.http.get(`${this.url}/sales-rep-assignees`).subscribe((data :any) => {
      this._assignee.next(<Assignee[]>data.records);
    });
  }

  search(keyword :string) :Subscription {
    const params = { business_name: keyword };
    this._loading.next(true);

    return this.http
      .get<any>(`${this.url}/companies`, { params: params })
      .subscribe((resp) => {
        const { data } = resp.records;
        this._companies.next(data);
        this._loading.next(false);

        return data;
      });
  }

  setCompanies(companies :Company[]) :void {
    this._companies.next(companies);
  }

  getCompanyByIds(companyIds :number[]) :Observable<any> {
    const params = { companyIds: JSON.stringify(companyIds) };

    return this.http.get<any>(`${this.url}/clients`, { params: params });
  }

  mergeCompany(payload :any) :Observable<any> {
    return this.http.post(`${this.urlV2}/business-accounts/merge`, payload).pipe(
      map((companies) => companies),
      filter((data) => data !== null),
    );
  }
}
